import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Jumbotron } from "./migration";
import Row from "react-bootstrap/Row";
import ProjectCard from "./ProjectCard";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
};
const API = "https://api.github.com";
const CACHE_TTL_MS = 5 * 60 * 1000;

// Shared across every <Project> instance for the life of the tab, so navigating
// between the home preview and the /work page doesn't re-fetch the same repos
// and burn through GitHub's unauthenticated rate limit (60/hr) twice as fast.
const repoCache = new Map();

const Project = ({ heading, username, length, specfic, limit, viewAllHref, order }) => {
  const allReposAPI = `${API}/users/${username}/repos?sort=updated&direction=desc`;
  const cacheKey = `${username}:${length}:${specfic.join(",")}`;
  const dummyCount = order ? order.length : limit || length + specfic.length;
  const dummyProjectsArr = new Array(dummyCount).fill(dummyProject);

  const [projectsArray, setProjectsArray] = useState(
    () => repoCache.get(cacheKey)?.data || []
  );

  const fetchRepos = useCallback(async () => {
    const cached = repoCache.get(cacheKey);
    if (cached && Date.now() - cached.time < CACHE_TTL_MS) {
      setProjectsArray(cached.data);
      return;
    }

    let repoList = [];
    try {
      // only hit the "recent repos" endpoint if we're actually asking for any
      if (length > 0) {
        const response = await axios.get(allReposAPI);
        repoList = [...response.data.slice(0, length)];
      }
      // adding specified repos — entries can be a bare repo name (assumed to
      // belong to `username`) or a full "owner/repo" string for repos you
      // contributed to but don't own
      try {
        for (let repoName of specfic) {
          const path = repoName.includes("/") ? repoName : `${username}/${repoName}`;
          const response = await axios.get(`${API}/repos/${path}`);
          repoList.push(response.data);
        }
      } catch (error) {
        console.error(error.message);
      }
      // most-recently-updated first
      repoList.sort((a, b) => new Date(b.pushed_at) - new Date(a.pushed_at));
      repoCache.set(cacheKey, { data: repoList, time: Date.now() });
      setProjectsArray(repoList);
    } catch (error) {
      console.error(error.message);
    }
  }, [allReposAPI, cacheKey, length, specfic, username]);

  useEffect(() => {
    fetchRepos();
  }, [fetchRepos]);

  let visibleProjects;
  if (order) {
    const byName = new Map(projectsArray.map((project) => [project.name, project]));
    visibleProjects = order
      .map((id) => byName.get(id.includes("/") ? id.split("/")[1] : id))
      .filter(Boolean);
  } else {
    visibleProjects = limit ? projectsArray.slice(0, limit) : projectsArray;
  }

  return (
    <Jumbotron fluid id="projects" className="m-0">
      <div className="d-flex justify-content-between align-items-baseline mb-4">
        <h2 className="section-heading">{heading}</h2>
        {viewAllHref && (
          <Link className="text-link" to={viewAllHref}>
            View all
          </Link>
        )}
      </div>
      <Row>
        {visibleProjects.length
          ? visibleProjects.map((project, index) => (
            <ProjectCard
              key={`project-card-${index}`}
              id={`project-card-${index}`}
              value={project}
            />
          ))
          : dummyProjectsArr.map((project, index) => (
            <ProjectCard
              key={`dummy-${index}`}
              id={`dummy-${index}`}
              value={project}
            />
          ))}
      </Row>
    </Jumbotron>
  );
};

export default Project;
